import React from 'react';
import LoaderComponent from './loader.style';
import { Spin } from 'antd';
export default Loader => (
  <LoaderComponent>
 <div className='loder'><Spin tip="Loading" size="large" /></div>
  </LoaderComponent>
);
